import React from "react"
import UnitSkeleton from "components/Skeleton/UnitSkeleton"

const MouldConfigurationSkeleton = () => {
   return (
      <div className="production-line-skeleton">
         <div className="production-line-skeleton-row ">
            <UnitSkeleton shape="rounded" size="small" />
         </div>
         <div className="production-line-skeleton-col">
            <UnitSkeleton shape="rounded" size="xsmall" />
            <UnitSkeleton shape="rounded" size="xsmall" />
            <UnitSkeleton shape="rounded" size="xsmall" />
            <UnitSkeleton shape="rounded" size="xsmall" />
         </div>
      </div>
   )
}

export default MouldConfigurationSkeleton
